import { CompanyNewInterface } from "../../models/GeneralModule/CompanyNews";
import client from "../client";

class CompanyNewService {
  async GetAll() {
    try {
      let url = `/api/CompanyNews/Get`;
      const { data } = await client.get<CompanyNewInterface[]>(url);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      let url = `/api/CompanyNews/GetById/${id}`;

      const { data } = await client.get<CompanyNewInterface>(url);

      return data;
    } catch (error) {
      throw error;
    }
  }

  async Save(companyNew: CompanyNewInterface) {
    try {
      let url = `/api/CompanyNews/Add`;

      const { data } = await client.post<CompanyNewInterface>(url, companyNew);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Update(id: string, companyNew: CompanyNewInterface) {
    try {
      let url = `/api/CompanyNews/Update/${id}`;

      const { data } = await client.post<CompanyNewInterface>(url, companyNew);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async Remove(id: string) {
    try {
      let url = `/api/CompanyNews/Remove/${id}`;
      await client.post<CompanyNewInterface>(url, { url: "" });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}

export default new CompanyNewService();
